import { SearchResult, SearchType } from '@/app/(main)/_components/search-modal/search-modal.types';

export const mostSearchedProceduresElasticHml: SearchResult[] = [
  {
    id: '9b6e575e-ff69-40d1-b4b0-0360de44be40',
    searchType: SearchType.PRESENTIAL_CONSULTATION,
    displayName: 'Consulta com Oftalmologista',
    subText: 'Consulta presencial - 10.10.10.12 - 225265',
    code: '10101012 - 225265',
    slug: 'oftalmologista',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: '66fee69a-5d9c-407b-9394-d928db0391a4',
    searchType: SearchType.PRESENTIAL_CONSULTATION,
    displayName: 'Consulta com Clínico Geral',
    subText: 'Consulta presencial - 10.10.10.12 - 225125',
    code: '10101012 - 225125',
    slug: 'consulta-em-consultorio-clinico-geral-ou-clinica-medica-50ec8a8bf1563a67b77b164f6ecff1d0',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: 'c2092b42-7fa8-4848-b146-91d43f3d10e9',
    searchType: SearchType.ONLINE_CONSULTATION,
    displayName: 'Teleconsulta com Clínico Geral',
    subText: 'Teleconsulta - 10.00.20.64',
    code: '10002064',
    slug: 'consulta-online-clinico-geral-ou-clinica-medica-telemedicina',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: 'fef6b80a-afa5-4995-8766-3f14caa20543',
    searchType: SearchType.LABORATORIAL_EXAM,
    displayName: 'Hemograma Completo (com Contagem de Plaquetas)',
    subText: 'Exame Laboratorial - 40.30.43.61',
    code: '40304361',
    slug: 'Hemograma',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: '9d25a081-6304-4664-988e-dd90f3ba71b3',
    searchType: SearchType.PRESENTIAL_CONSULTATION,
    displayName: 'Consulta com Psiquiatra',
    subText: 'Consulta presencial - 10.10.10.12 - 225133',
    code: '10101012 - 225133',
    slug: 'psiquiatra',
    source: 'ELASTIC_SEARCH',
  },
];
